import React from 'react'
import * as S from './PillSwitch.styled'
import type { Props } from './types'

export const PillSwitch = ({ size = 'regular', items, value, onChange }: Props) => {
  const handleClick: Props['onChange'] = (value) => {
    onChange?.(value)
  }

  if (items.length === 0) {
    return null
  }

  return (
    <nav>
      <S.List>
        {items.map((item) => (
          <li key={item.value}>
            <S.ItemButton
              $size={size}
              $isActive={item.value === value}
              onClick={() => handleClick(item.value)}
            >
              {item.label}
            </S.ItemButton>
          </li>
        ))}
      </S.List>
    </nav>
  )
}
